export default `{
  "wait_for": 6000
}`